// src/utils/cashBackUtils.js

export function getCashBackPercent(item) {
    return Number(item?.cashBackPercent || item?.CashBackPercent || 0);
}

export function resolveCashBackPercent(configPedido, grupo, produto) {
    const produtoCashBackPercent = getCashBackPercent(produto);
    if (produtoCashBackPercent > 0) {
        return produtoCashBackPercent;
    }

    const grupoCashBackPercent = getCashBackPercent(grupo) || getCashBackPercent(produto?.grupo);
    if (grupoCashBackPercent > 0) {
        return grupoCashBackPercent;
    }

    return getCashBackPercent(configPedido);
}

export function calculateCashBackValue(valor, cashBackPercent) {
    return (Number(valor) || 0) * ((Number(cashBackPercent) || 0) / 100);
}
